/**
 * The legal-block catalog (ADR-0090 / REGTA-87). Regta-owned, Regta-scoped
 * (global — no tenant column), served to Hyran via `api.catalog.*`.
 *
 * >>> LEGAL-REVIEW-PENDING (Tier-3): the `legalText` below is authored to unblock
 *     the catalog API + Hyran's composition lane. Before this catalog is used for
 *     production documents, each string MUST be verified verbatim against the
 *     Haymanot-approved source (the forhandlingsframstallning/v1 template text)
 *     and frozen. A wording change is a NEW version, never an in-place edit. <<<
 */
const BLOCKS = [
    {
        blockKey: 'framstallan.preamble',
        version: 'v3',
        plane: 'legal',
        kind: 'clause',
        title: 'Förhandlingsframställan',
        legalText: 'Med stöd av gällande förhandlingsordning och 15 § hyresförhandlingslagen ' +
            '(1978:304) påkallar hyresvärden förhandling enligt nedanstående yrkanden.',
        slots: [],
        summary: 'Statutory preamble invoking 15 § HFL — frozen, legal-reviewed.',
    },
    {
        blockKey: 'framstallan.yrkande',
        version: 'v2',
        plane: 'legal',
        kind: 'yrkande',
        title: 'Yrkande',
        legalText: 'Hyresvärden yrkar att hyran ska ändras enligt de grunder och det underlag ' +
            'som redovisas nedan, att gälla från angiven dag.',
        slots: [{ key: 'galler_fran', label: 'Gäller från', type: 'date', required: true, statutory: false }],
        summary: 'The petition line — the operative claim.',
    },
    {
        blockKey: 'framstallan.delgivning',
        version: 'v2',
        plane: 'legal',
        kind: 'signing',
        title: 'Delgivning och underskrift',
        legalText: 'Denna framställan har översänts till motparten. Undertecknad intygar ' +
            'riktigheten av lämnade uppgifter.',
        slots: [],
        summary: 'Delivery + signature scaffold. The signers list is rendered Hyran-side.',
    },
];
/** blockKey → version → block. Mirrors the (templateKey, version) registry pattern. */
export const BLOCK_CATALOG = (() => {
    const out = {};
    for (const b of BLOCKS) {
        (out[b.blockKey] ??= {})[b.version] = b;
    }
    return out;
})();
export function listCatalogBlocks(opts) {
    const all = Object.values(BLOCK_CATALOG).flatMap((byVersion) => Object.values(byVersion));
    return opts?.plane ? all.filter((b) => b.plane === opts.plane) : all;
}
export function getCatalogBlock(blockKey, version) {
    return BLOCK_CATALOG[blockKey]?.[version];
}
//# sourceMappingURL=registry.js.map